import {
    getPortfoliosFilteredData,
    mapInvestorDetailsToPortfolios,
} from '../../components/dashboard/portfolios/utils';
import { addDialCode } from '../../utils/constants';
import { EncodeBase64 } from '../../utils/utilityFunctions';
import { CALL_API } from '../middleware';
import { RootStateType } from '../reducers';
import {
    SEND_EMAIL_OTP,
    SEND_EMAIL_OTP_SUCCESS,
    SEND_SMS_OTP,
    SEND_SMS_OTP_SUCCESS,
    UPDATE_EMAIL,
    UPDATE_EMAIL_SUCCESS,
    UPDATE_MOBILE,
    UPDATE_MOBILE_SUCCESS,
    VERIFY_CHANGE_EMAIL_OTP,
    VERIFY_CHANGE_EMAIL_OTP_SUCCESS,
    UPDATE_DIVIDEND_SUCCESS,
    UPDATE_DIVIDEND,
    FETCH_TRACK_STATUS_SUCCESS,
    FETCH_TRACK_STATUS,
    UPDATE_NOMINEE_SUCCESS,
    UPDATE_NOMINEE,
    FETCH_INVESTOR_DETAILS_SUCCESS,
    FETCH_INVESTOR_DETAILS,
    CONSOLIDATION_FOLIOS_SUCCESS,
    CONSOLIDATION_FOLIO,
    UPDATE_DATA_ENTRY_SUCCESS,
    UPDATE_DATA_ENTRY,
    UPDATE_TAX_STATUS_SUCCESS,
    UPDATE_TAX_STATUS,
    MINOR_TO_MAJOR,
    MINOR_TO_MAJOR_SUCCESS,
    UPDATE_IFSC,
    UPDATE_IFSC_SUCCESS,
    UPDATE_BANK_DETAILS,
    UPDATE_BANK_DETAILS_SUCCESS,
    UPDATE_MULTIPLE_BANKS,
    UPDATE_MULTIPLE_BANKS_SUCCESS,
    GET_FATCA_DETAILS,
    GET_FATCA_DETAILS_SUCCESS,
    UPDATE_FATCA_DETAILS,
    UPDATE_FATCA_DETAILS_SUCCESS,
    FETCH_IFSC_DETAILS,
    FETCH_IFSC_DETAILS_SUCCESS,
    UPDATE_PRELOGIN_PAN,
    UPDATE_PRELOGIN_PAN_SUCCESS,
    UPDATE_FORM_15,
    UPDATE_FORM_15_SUCCESS,
    SEND_PHONE_OTP_PAYLOAD,
    GET_AMC_LIST_SUCCESS,
    GET_AMC_LIST,
    AMC_LIST_RESPONSE,
    GET_ALL_SECURITY_QUESTIONS_SUCCESS,
    GET_ALL_SECURITY_QUESTIONS,
    GET_ALL_SECURITY_QUESTIONS_ANSWERS_SUCCESS,
    GET_ALL_SECURITY_QUESTIONS_ANSWERS,
    UPDATE_SECURITY_QUESTIONS_SUCCESS,
    UPDATE_SECURITY_QUESTIONS,
    GIVE_FEEDBACK_SUCCESS,
    GIVE_FEEDBACK,
    INVETSOR_DETAILS_RESPONSE,
    INVESTOR_OBJECT,
    DOWNLOAD_SUMMARY_SUCCESS,
    DOWNLOAD_SUMMARY,
    GENERATE_DETAILED_SUCCESS,
    GENERATE_DETAILED,
    DOWNLOAD_DETAILED_SUCCESS,
    DOWNLOAD_DETAILED,
    FETCH_ALL_CAS_HISTORY_SUCCESS,
    FETCH_ALL_CAS_HISTORY,
    SAVE_DISPLAY_NAME,
    SAVE_DISPLAY_NAME_SUCCESS,
    ImageSaveType,
    SAVE_IMAGE_DATA,
    TRANSMISSION_UNITS,
    TRANSMISSION_UNITS_SUCCESS,
    GET_CRM_DATA,
    GET_CRM_DATA_SUCCESS,
    CRM_DETAILS,
    PRE_LOGIN_TRANSMISSION,
    PRE_LOGIN_TRANSMISSION_SUCCESS,
    FETCH_COMMERCIAL_TRACK_STATUS,
    FETCH_COMMERCIAL_TRACK_STATUS_SUCCESS,
    FETCH_ALL_CGS_HISTORY_SUCCESS,
    FETCH_ALL_CGS_HISTORY,
    GET_CGS_DETAIL_SUCCESS,
    GET_CGS_DETAIL,
    GET_CGS_DOCUMENT_SUCCESS,
    GET_CGS_DOCUMENT,
} from '../types/nct';
import { LIST_PROTFOLIO_PAYLOAD, PORTFOLIO_RESPONSE_PAYLOAD } from '../types/portfolio';
import store from '../../store';
import { FORGOT_QA } from '../types/login';

export const sendEmailOTP =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: `/otpwrapper/generateEmailOtp`,
                    method: 'POST',
                    types: [SEND_EMAIL_OTP_SUCCESS, SEND_EMAIL_OTP],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const sendPhoneOTP =
    (body: SEND_PHONE_OTP_PAYLOAD) =>
    async (dispatch: any): Promise<any> => {
        try {
            const { mobile, ...rest } = body;
            return await dispatch({
                [CALL_API]: {
                    url: `/otpwrapper/generate${
                        store.getState().authReducer.userRegisteredWith === 'EMAIL'
                            ? 'Email'
                            : 'Sms'
                    }Otp`,
                    method: 'POST',
                    types: [SEND_SMS_OTP_SUCCESS, SEND_SMS_OTP],
                    body:
                        store.getState().authReducer.userRegisteredWith === 'EMAIL'
                            ? {
                                  ...rest,
                                  email: store.getState().authReducer.email,
                              }
                            : {
                                  ...rest,
                                  mobile: addDialCode(mobile),
                                  email: '',
                              },
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

// The below function is used to update the mobile number for a email user
export const sendMobileOTP =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: `/otpwrapper/generateSmsOtp`,
                    method: 'POST',
                    types: [SEND_SMS_OTP_SUCCESS, SEND_SMS_OTP],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const updateEmail =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: `/nft/updateEmail`,
                    method: 'POST',
                    types: [UPDATE_EMAIL_SUCCESS, UPDATE_EMAIL],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const verifyChangeEmailOTP = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/otpwrapper/verifyotp`,
                method: 'POST',
                types: [VERIFY_CHANGE_EMAIL_OTP_SUCCESS, VERIFY_CHANGE_EMAIL_OTP],
                body: { ...body, enteredOtp: EncodeBase64(body.enteredOtp) },
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const updateMobile = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: `/nft/updateMobile`,
                method: 'POST',
                types: [UPDATE_MOBILE_SUCCESS, UPDATE_MOBILE],
                body,
            },
        });
    } catch (error: any) {
        throw error;
    }
};

export const updateDividend =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: `/nft/updateDividend`,
                    method: 'POST',
                    types: [UPDATE_DIVIDEND_SUCCESS, UPDATE_DIVIDEND],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const validateTransmission = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/nft/validateTransmission',
                method: 'POST',
                types: [PRE_LOGIN_TRANSMISSION_SUCCESS, PRE_LOGIN_TRANSMISSION],
                body,
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const getTrackStatus =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: `/notify/getstatus`,
                    method: 'POST',
                    types: [FETCH_TRACK_STATUS_SUCCESS, FETCH_TRACK_STATUS],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const getCommercialTrackStatus =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: `/notify/getFTStatus`,
                    method: 'POST',
                    types: [FETCH_COMMERCIAL_TRACK_STATUS_SUCCESS, FETCH_COMMERCIAL_TRACK_STATUS],
                    body,
                    enableFixture: false,
                    // json: 'commercial-track.json',
                    json: 'commercial-track-single.json',
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const fetchInvestorDetails =
    (body: LIST_PROTFOLIO_PAYLOAD) =>
    async (dispatch: any, getState: any): Promise<any> => {
        const {
            authReducer: { email = '' },
        } = store.getState();
        const { portfolio }: RootStateType = getState();
        const { data: folioList = [] }: PORTFOLIO_RESPONSE_PAYLOAD = portfolio?.portfolios || {};
        const filterdByFolio = getPortfoliosFilteredData(folioList);
        try {
            const { body: responseBody = {}, ...responseProps } = await dispatch({
                [CALL_API]: {
                    url: `/user/getInvestorDetails`,
                    method: 'POST',
                    types: [FETCH_INVESTOR_DETAILS_SUCCESS, FETCH_INVESTOR_DETAILS],
                    body: { ...body, email },
                    enableFixture: true,
                    json: `investorDetails.json`,
                },
            });
            const { success: data = [], ...rest } = responseBody;
            const filteredFunds: any = mapInvestorDetailsToPortfolios(data, filterdByFolio);
            const funds = filteredFunds.reduce(
                (prev: INVETSOR_DETAILS_RESPONSE[], { amc, amcName, ...fund }: INVESTOR_OBJECT) => {
                    const index = prev.findIndex((fund) => fund.amc === amc);
                    if (index === -1) {
                        return [...prev, { amc, amcName, investorDetails: [fund] }];
                    }
                    prev[index].investorDetails = [...prev[index].investorDetails, fund];
                    return prev;
                },
                [],
            );
            return { body: { success: funds, ...rest }, ...responseProps };
        } catch (error: any) {
            throw error;
        }
    };

export const updateNominee =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: `/nft/updateNominee`,
                    method: 'POST',
                    types: [UPDATE_NOMINEE_SUCCESS, UPDATE_NOMINEE],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const consolidationFolios =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/consolidationFolios',
                    method: 'POST',
                    types: [CONSOLIDATION_FOLIOS_SUCCESS, CONSOLIDATION_FOLIO],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const updateDataEntry =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/updateDataEntry',
                    method: 'POST',
                    types: [UPDATE_DATA_ENTRY_SUCCESS, UPDATE_DATA_ENTRY],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const updateTaxStatus =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/updateTaxStatus',
                    method: 'POST',
                    types: [UPDATE_TAX_STATUS_SUCCESS, UPDATE_TAX_STATUS],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const updateMinorToMajor =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/updateMinorToMajor',
                    method: 'POST',
                    types: [MINOR_TO_MAJOR_SUCCESS, MINOR_TO_MAJOR],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const updateIFSC =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/updateBankAccountType',
                    method: 'POST',
                    types: [UPDATE_IFSC_SUCCESS, UPDATE_IFSC],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const updateBankDetails =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/updateBankAccountDetails',
                    method: 'POST',
                    types: [UPDATE_BANK_DETAILS_SUCCESS, UPDATE_BANK_DETAILS],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const updateMultipleBanks =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/multiBankMandate',
                    method: 'POST',
                    types: [UPDATE_MULTIPLE_BANKS_SUCCESS, UPDATE_MULTIPLE_BANKS],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const getFatcaDetails =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getFatcaDetails',
                    method: 'POST',
                    types: [GET_FATCA_DETAILS_SUCCESS, GET_FATCA_DETAILS],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const updateFATCA =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/updateFatca',
                    method: 'POST',
                    types: [UPDATE_FATCA_DETAILS_SUCCESS, UPDATE_FATCA_DETAILS],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const fetchIFSCDetails =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            const {
                authReducer: { email = '' },
            } = store.getState();
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getIfscDetails',
                    method: 'POST',
                    types: [FETCH_IFSC_DETAILS_SUCCESS, FETCH_IFSC_DETAILS],
                    body: { ...body, email },
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const updatePreLoginPan =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/updatePanPrelogin',
                    method: 'POST',
                    types: [UPDATE_PRELOGIN_PAN_SUCCESS, UPDATE_PRELOGIN_PAN],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const updateForm15GH =
    (body: any) =>
    async (dispatch: any): Promise<any> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/nft/updateForm15GH',
                    method: 'POST',
                    types: [UPDATE_FORM_15_SUCCESS, UPDATE_FORM_15],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const getForm15Info =
    (body: LIST_PROTFOLIO_PAYLOAD) =>
    async (dispatch: any): Promise<any> => {
        try {
            const {
                authReducer: { email = '' },
            } = store.getState();
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getForm15GOrH',
                    method: 'POST',
                    types: [FETCH_IFSC_DETAILS_SUCCESS, FETCH_IFSC_DETAILS],
                    body: { ...body, email },
                    // enableFixture: true,
                    json: 'form15G.json',
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const getAmcList =
    () =>
    async (dispatch: any): Promise<{ body: AMC_LIST_RESPONSE[] }> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/user/amc-list',
                    method: 'GET',
                    types: [GET_AMC_LIST_SUCCESS, GET_AMC_LIST],
                    enableFixture: true,
                    json: 'amcList.json',
                    enableForProduction: true,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const getSecurityQuestions =
    (body: any) =>
    async (dispatch: any): Promise<{ body: AMC_LIST_RESPONSE[] }> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getAllSecurityQuestions',
                    method: 'POST',
                    types: [GET_ALL_SECURITY_QUESTIONS_SUCCESS, GET_ALL_SECURITY_QUESTIONS],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const getSecretQuestionsAnswers =
    (body: any) =>
    async (dispatch: any): Promise<{ body: AMC_LIST_RESPONSE[] }> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getSecurityQuestionsAnswersForUser',
                    method: 'POST',
                    types: [
                        GET_ALL_SECURITY_QUESTIONS_ANSWERS_SUCCESS,
                        GET_ALL_SECURITY_QUESTIONS_ANSWERS,
                    ],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const getSecurityQuestionsForgotQA =
    (body: any) =>
    async (dispatch: any): Promise<{ body: AMC_LIST_RESPONSE[] }> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getAllSecurityQuestionsForForgotQA',
                    method: 'POST',
                    types: [GET_ALL_SECURITY_QUESTIONS_SUCCESS, GET_ALL_SECURITY_QUESTIONS],
                    body: {
                        ...body,
                        action: FORGOT_QA,
                    },
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const updateSecurityQuestionsForUser =
    (body: any) =>
    async (dispatch: any): Promise<{ body: AMC_LIST_RESPONSE[] }> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/user/updateSecurityQuestionsAnswersForUser',
                    method: 'POST',
                    types: [UPDATE_SECURITY_QUESTIONS_SUCCESS, UPDATE_SECURITY_QUESTIONS],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const updateSecurityQuestionsForUserResetQA =
    (body: any) =>
    async (dispatch: any): Promise<{ body: any }> => {
        try {
            return await dispatch({
                [CALL_API]: {
                    url: '/user/newSecurityQuestionsAnswersForUser',
                    method: 'POST',
                    types: [UPDATE_SECURITY_QUESTIONS_SUCCESS, UPDATE_SECURITY_QUESTIONS],
                    body,
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const giveFeedback =
    (body: any) =>
    async (dispatch: any): Promise<{ body: AMC_LIST_RESPONSE[] }> => {
        try {
            const {
                authReducer: { email = '' },
            } = store.getState();
            return await dispatch({
                [CALL_API]: {
                    url: '/user/contactUs',
                    method: 'POST',
                    types: [GIVE_FEEDBACK_SUCCESS, GIVE_FEEDBACK],
                    body: { ...body, email },
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const downloadSummaryPDF =
    (body: any) =>
    async (dispatch: any): Promise<{ body: any }> => {
        try {
            const {
                authReducer: { email = '' },
            } = store.getState();
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getCasSummary',
                    method: 'POST',
                    types: [DOWNLOAD_SUMMARY_SUCCESS, DOWNLOAD_SUMMARY],
                    body: { ...body, email },
                    contentType: 'application/pdf',
                },
            });
        } catch (error: any) {
            throw error;
        }
    };
export const generateCgsDetailedPDF =
    (body: any) =>
    async (dispatch: any): Promise<{ body: any }> => {
        try {
            const {
                authReducer: { email = '' },
            } = store.getState();
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getCgsDetail',
                    method: 'POST',
                    types: [GENERATE_DETAILED_SUCCESS, GENERATE_DETAILED],
                    body: { ...body, email },
                    contentType: 'application/pdf',
                },
            });
        } catch (error: any) {
            throw error;
        }
    };


export const generateDetailedPDF =
    (body: any) =>
    async (dispatch: any): Promise<{ body: any }> => {
        try {
            const {
                authReducer: { email = '' },
            } = store.getState();
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getCasDetail',
                    method: 'POST',
                    types: [GENERATE_DETAILED_SUCCESS, GENERATE_DETAILED],
                    body: { ...body, email },
                    contentType: 'application/pdf',
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const downloadDetailedPDF =
    (body: any) =>
    async (dispatch: any): Promise<{ body: any }> => {
        try {
            const {
                authReducer: { email = '' },
            } = store.getState();
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getCasDocument',
                    method: 'POST',
                    types: [DOWNLOAD_DETAILED_SUCCESS, DOWNLOAD_DETAILED],
                    body: { ...body, email },
                    contentType: body.fileType === 'pdf' ? 'application/pdf' : 'application/vnd.ms-excel',
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const getCasHistory =
    (body: any) =>
    async (dispatch: any): Promise<{ body: any }> => {
        try {
            const {
                authReducer: { email = '' },
            } = store.getState();
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getCasHistory',
                    method: 'POST',
                    types: [FETCH_ALL_CAS_HISTORY_SUCCESS, FETCH_ALL_CAS_HISTORY],
                    body: { ...body, email },
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const getCgsHistory =
    (body: any) =>
    async (dispatch: any): Promise<{ body: any }> => {
        try {
            const {
                authReducer: { email = '' },
            } = store.getState();
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getCgsHistory',
                    method: 'POST',
                    types: [FETCH_ALL_CGS_HISTORY_SUCCESS, FETCH_ALL_CAS_HISTORY],
                    body: { ...body, email },
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const getCgsDetail =
    (body: any) =>
    async (dispatch: any): Promise<{ body: any }> => {
        try {
            const {
                authReducer: { email = '' },
            } = store.getState();
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getCgsDetail',
                    method: 'POST',
                    types: [GET_CGS_DETAIL_SUCCESS, GET_CGS_DETAIL],
                    body: { ...body, email },
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const getCgsDocument =
    (body: any) =>
    async (dispatch: any): Promise<{ body: any }> => {
        try {
            const {
                authReducer: { email = '' },
            } = store.getState();
            return await dispatch({
                [CALL_API]: {
                    url: '/user/getCgsDocument',
                    method: 'POST',
                    types: [GET_CGS_DOCUMENT_SUCCESS, GET_CGS_DOCUMENT],
                    body: { ...body, email },
                    contentType: 'application/vnd.ms-excel',
                },
            });
        } catch (error: any) {
            throw error;
        }
    };

export const onSaveDisplayName = (body: any) => async (dispatch: any) => {
    try {
        const {
            authReducer: { email = '' },
        } = store.getState();
        return await dispatch({
            [CALL_API]: {
                url: '/user/updateDisplayNameForUser',
                method: 'POST',
                types: [SAVE_DISPLAY_NAME_SUCCESS, SAVE_DISPLAY_NAME],
                body: { ...body, email },
            },
        });
    } catch (err: any) {
        throw err;
    }
};

export const onSaveImageData = (body: { action: ImageSaveType }) => {
    return {
        body,
        type: SAVE_IMAGE_DATA,
    };
};

export const transmissionUnits = (body: any) => async (dispatch: any) => {
    try {
        return await dispatch({
            [CALL_API]: {
                url: '/nft/transmissionOfUnits',
                method: 'POST',
                types: [TRANSMISSION_UNITS_SUCCESS, TRANSMISSION_UNITS],
                body,
            },
        });
    } catch (err) {
        throw err;
    }
};
export const getCRMDetails =
    (body: LIST_PROTFOLIO_PAYLOAD) =>
    async (dispatch: any): Promise<CRM_DETAILS | undefined> => {
        try {
            const {
                authReducer: { email = '' },
            } = store.getState();
            return await dispatch({
                [CALL_API]: {
                    url: `/user/getcrmdetails`,
                    method: 'POST',
                    types: [GET_CRM_DATA, GET_CRM_DATA_SUCCESS],
                    body: { ...body, email },
                    // enableFixture: true,
                    // json: 'crm.json',
                },
            });
        } catch (error: any) {
            throw error;
        }
    };
